/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shared_FlexibleDate } from './shared_FlexibleDate';
export type allocations_UpdateAllocationRequest = {
    /**
     * AgeTypeCode to update (BABY or CHILD)
     */
    age_type_code?: allocations_UpdateAllocationRequest.age_type_code;
    /**
     * ChildID to update
     */
    child_id?: string;
    /**
     * ContractID to update
     */
    contract_id?: string;
    /**
     * ExpectedUpdatedAt for optimistic concurrency control - server will check this matches the current updated_at and return 409 if different
     */
    expected_updated_at?: string;
    friday_services?: Array<string>;
    /**
     * FromDate to update
     */
    from_date?: shared_FlexibleDate;
    /**
     * GroupID to update
     */
    group_id?: string;
    /**
     * Weekday services to update
     */
    monday_services?: Array<string>;
    saturday_services?: Array<string>;
    sunday_services?: Array<string>;
    thursday_services?: Array<string>;
    /**
     * ToDate to update
     */
    to_date?: shared_FlexibleDate;
    tuesday_services?: Array<string>;
    wednesday_services?: Array<string>;
};
export namespace allocations_UpdateAllocationRequest {
    /**
     * AgeTypeCode to update (BABY or CHILD)
     */
    export enum age_type_code {
        BABY = 'BABY',
        CHILD = 'CHILD',
    }
}

